import {Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';

@Directive({
  selector: '[appHighlight]'
})
export class HighlightDirective implements OnChanges {
  @Input() searchedWords!: string[];
  @Input() text!: string;
  @Input() classToApply!: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnChanges(_: SimpleChanges): void {
    if (!this.searchedWords || !this.searchedWords.length || !this.classToApply) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);
      return;
    }

    this.renderer.setProperty(
      this.el.nativeElement,
      'innerHTML',
      this.getFormattedText()
    );
  }

  getFormattedText() {
    const re = new RegExp(`(${this.searchedWords.join('|')})`, 'g');

    return this.text.replace(re, `<span class="${this.classToApply}">$1</span>`);
  }
}
